import { fetchGet } from '~utilities/fetch';

export async function valuersListRequest(): Promise<Response> {
    return fetchGet('/valuers');
}
